import { get } from './config'

const sendOfferRedemption = (userId, offerId) => {
    return fetch(`${get('redemptionApiUrl')}/redeem`, {
        method: 'POST',
        body: JSON.stringify({
            userId,
            offerId,
            centreId: get('centreId')
        })
    })
        .then((response) => response.json())
}

const retrieveUserRedemptions = (userId) => {
    const baseUrl = `${get('redemptionApiUrl')}/redemptions`
    let url = new URL(baseUrl)
    url.searchParams.append('userId', userId)
    url.searchParams.append('centreId', get('centreId'))

    return fetch(url).then((response) => response.json())
}

export { sendOfferRedemption, retrieveUserRedemptions }



// WEBPACK FOOTER //
// ./lib/redemption.js